const $inject = ['$rootScope', '$location', '$routeParams', 'settingsService', 'dataService', 'subNavService'];

const lbaTabsCtrl = function ($rootScope, $location, $routeParams, settingsService, dataService, subNavService) {
  const vm = this;
  const paths = $location.$$path.split('/');
  vm.dataService = dataService;

  vm.showDropDown = false;

  if (!dataService.data.activeItem || dataService.data.activeItem && vm.settings.routeParamId && dataService.data.activeItem.Id !== $routeParams[vm.settings.routeParamId]) {
    dataService.get(vm.settings.endpoint, $routeParams[vm.settings.routeParamId]).then((data) => {

      if (Array.isArray(data)) {
        dataService.data.activeItem = data[0];
      } else {
        dataService.data.activeItem = data;
      }

      vm.ready = true;
    });
  } else {
    vm.ready = true;
  }

  vm.activeItem = paths[ paths.length-1 ].replace(/\s+/g, '-');
  vm.fields = settingsService.settings.fields;
  vm.showTab = showTab;
  vm.clickOutside = clickOutside;
  vm.getOptions = getOptions;
  subNavService.navObj = createSubNav(vm.settings.children);

  function showTab(tab) {
    // JLF: LOBT-773: we must reset the grid cache with every fresh page being shown
    dataService.backGridFilter = null;
    dataService.backGridPage = null;
    dataService.backViewGridFilter = null;
    dataService.backViewGridPage = null;

    paths[ paths.length-1 ] = tab.tabName.replace(/\s+/g, '-').toLowerCase();
    $location.path(paths.join('/'));
  }

  function clickOutside() {
    vm.showDropDown = false;
  }

  function getOptions() {
    const fields = [];
    vm.settings.children.forEach((item) => {
      fields.push(vm.fields[item].tabName);
    });

    return fields
  }

  function createSubNav(data) {
    if (data.length === 0) {
      return [];
    }

    const nav = [];

    data.forEach(item => {
      let tabName = item.tabName;

      nav.push({
        name: tabName.split('-').join(' '),
        link: buildLink(tabName),
        active: vm.activeItem === tabName.toLowerCase()
      })
    });

    function buildLink(tabName) {
      paths[ paths.length-1 ] = tabName.replace(/\s+/g, '-').toLowerCase();
      return paths.join('/');
    }

    $rootScope.showSubNav = true;
    return nav;
  }
};

lbaTabsCtrl.$inject = $inject;

export default lbaTabsCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaTabs/lbaTabsCtrl.js